import React, { CSSProperties } from 'react';
import { Box } from '@material-ui/core';

import FsPaper from 'ui-elements/main-elements/FsPaper';
import FsCircularProgress from 'ui-elements/loaders/FsCircularProgress';

interface FsLoaderProps {
  style?: CSSProperties;
  withShadow?: boolean;
  withMargin?: boolean;
}

const FsLoader: React.FC<FsLoaderProps> = ({
  style,
  withShadow,
  withMargin = true,
}) => {
  const defaultStyle: CSSProperties = {
    marginBottom: withMargin ? 24 : 0,
  };

  return (
    <FsPaper
      style={{ ...defaultStyle, ...style }}
      withShadow={withShadow}
      withContentMargin={false}
    >
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        width="100%"
        minHeight={style?.minHeight || 100}
      >
        <FsCircularProgress />
      </Box>
    </FsPaper>
  );
};

export default FsLoader;
